// extracted by mini-css-extract-plugin
export var centerResponsive = "Content-module--centerResponsive--f1e5a";
export var container = "Content-module--container--d3e8a";
export var reverseResponsive = "Content-module--reverseResponsive--3e601";